import React from "react";
import classNames from "classnames";
import useDayAndTimeFromEventStartTime from "@hooks/useDayAndTimeFromEventStartTime";
import SportMonoIcon from "@components/icons/SportMonoIcon";

export function QuickPlayEventTime(props: {
	startTime: string;
	sportAbrv?: string;
	containerClassName?: string;
	sportIconClassName?: string;
	timeTextClassName?: string;
}) {
	const { day, time } = useDayAndTimeFromEventStartTime(
		props.startTime,
		true
	);

	const containerClassName = classNames(
		"card--qp__info card--mpt__info",
		props.containerClassName
	);

	const sportIconClassName = classNames(
		"card--mpt__info__sport u-icon u-icon--sml u-icon--sport u-icon--sport--mono",
		props.sportIconClassName
	);

	const timeTextClassName = classNames(
		"card--mpt__info__time",
		props.timeTextClassName
	);

	return (
		<div className={containerClassName}>
			{props.sportAbrv && (
				<SportMonoIcon
					sportAbrv={props.sportAbrv}
					className={sportIconClassName}
				/>
			)}
			<span className={timeTextClassName}>
				<strong className="u-type--wgt--medium">{day}</strong> {time}
			</span>
		</div>
	);
}
